"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("../../atoms");
const providers_1 = require("../../providers");
const animation_1 = require("../../utils/animation");
const ColorsOptions_1 = __importDefault(require("../ColorsOptions"));
const OpacitySlider_1 = __importDefault(require("../OpacitySlider"));
const SizesOptions_1 = __importDefault(require("../SizesOptions"));
function DrawOptionsPanel({ colors = [], sizes = [1, 2, 3, 4], withOpacity = false, color = '', size = 2, initialOpacity = 0, className, onChangeColor = noop_1.default, onChangeSize = noop_1.default, onChangeOpacity = noop_1.default, onToggle = noop_1.default, }) {
    const [isActive, setActive] = (0, react_1.useState)(false);
    const [opacity, setOpacity] = (0, react_1.useState)(initialOpacity);
    const containerRef = (0, react_1.useRef)(null);
    const [, setGuidesState] = (0, providers_1.useGuidesContext)();
    const onActive = () => {
        onToggle(!isActive);
        setActive(!isActive);
        setGuidesState(prev => (Object.assign(Object.assign({}, prev), { isHideGuidesPanel: !isActive })));
    };
    const onClickOutside = () => {
        onToggle(false);
        setActive(false);
        setGuidesState(prev => (Object.assign(Object.assign({}, prev), { isHideGuidesPanel: false })));
    };
    const onChangeOpacitySlider = (value) => {
        setOpacity(value);
    };
    (0, ui_1.useOutsideClick)(containerRef, onClickOutside);
    (0, react_1.useEffect)(() => {
        setOpacity(opacity); //NOSONAR
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialOpacity]);
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, className: className, role: "dialog", "data-testid": "draw-options", "data-e2e": 'DrawOptionsPanel_Container', children: [(0, jsx_runtime_1.jsx)(StyledColorsOptions, { colors: colors, currentColor: color, active: isActive, onSelect: onChangeColor, "data-e2e": 'DrawOptionsPanel_StyledColorsOptions' }), withOpacity && ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isActive, timeout: 300, "data-e2e": 'DrawOptionsPanel_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledOpacitySlider, { color: color, opacity: opacity, onChange: onChangeOpacitySlider, onAfterChange: onChangeOpacity, "data-e2e": 'DrawOptionsPanel_StyledOpacitySlider' }) })), (0, jsx_runtime_1.jsx)(StyledSizesOptions, { cube: false, sizes: sizes, currentSize: size, active: isActive, onSelect: onChangeSize, "data-e2e": 'DrawOptionsPanel_StyledSizesOptions' }), (0, jsx_runtime_1.jsx)(atoms_1.ColorButton, { color: color, active: isActive, size: size, opacity: withOpacity ? opacity : 1.0, onClick: onActive, "data-e2e": 'DrawOptionsPanel_ColorButton' })] }));
}
exports.default = DrawOptionsPanel;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;

  height: 50px;
`;
const StyledOpacitySlider = (0, styled_components_1.default)(OpacitySlider_1.default) `
  position: absolute;
  bottom: -300px;
  left: calc(50% - 10px);

  ${(0, animation_1.SlideUp)('380px')}
`;
const StyledColorsOptions = (0, styled_components_1.default)(ColorsOptions_1.default) `
  position: absolute;
  top: 5px;
  right: 100%;
`;
const StyledSizesOptions = (0, styled_components_1.default)(SizesOptions_1.default) `
  position: absolute;
  top: 0;
  left: 100%;

  padding-left: 30px;
`;
